(function($) {
    'use strict';
    var $body = $('body'),
        $menu_wrap = $('.main-menu--wrap');

    // === SCROLL LINK HOMEPAGE
    $(function() {
        $(document).on('click', 'a[href^="/#"]', function (event) {
            var sect_id = $($(this).attr("href").replace(/^\/+|\/+$/g, ''));
            if(sect_id.length) {
                event.preventDefault();
                $("html, body").animate({scrollTop: $(sect_id).offset().top}, 500);
            }
        });
    });
    // === END OF SCROLL LINK HOMEPAGE

    //----- Mobile submenu toggle
    $('.mobile-menu-button').on('click', function (e) {
        // $body.toggleClass('menu-in');
        $('.mobile-menu-button .btn').toggleClass('active');
        $menu_wrap.toggleClass('visible');
    });

    $('.primary-menu li a').on('click', function (e) {
        $('.mobile-menu-button .btn').toggleClass('active');
        $menu_wrap.toggleClass('visible');
    });

})(jQuery);
